import {useState, useCallback, useEffect} from 'react';
import accounts from 'accounts/Accounts.js';
import sequenceMetadata from 'decentralized/sequences/SequenceMetadata.js';

export const useProjectMetadata = ({track, guildId=0}) => {
    const [isFavorited, setIsFavorited] = useState(false);
    const [isStarred, setIsStarred] = useState(false);
    const [showStar, setShowStar] = useState(false);

    async function onFavoriteClicked(e) {
        e.stopPropagation();

        if (!accounts.isLoggedIn()) {
            return;
        }

        if (isFavorited) {
            sequenceMetadata.unfavoriteSequence(track.id, guildId);
            setIsFavorited(false);
        } else {
            sequenceMetadata.favoriteSequence(track.id, guildId);
            setIsFavorited(true);
        }
    }

    async function onStarClicked(e) {
        e.stopPropagation();
        let account = await accounts.getAccount();
        if (!accountsEqual(account, track.user)) {
            return;
        }

        if (isStarred) {
            sequenceMetadata.unstarSequence(track.id, guildId);
            setIsStarred(false);
        } else {
            sequenceMetadata.starSequence(track.id, guildId);
            setIsStarred(true);
            setShowStar(true);
        }
    }

    useEffect(() => {
        fetchIsFavorited(track.id, setIsFavorited);
        fetchIsStarred(track, setShowStar, setIsStarred);
    }, [track.blockNumber, setIsStarred, setShowStar, track]);

    return {
        showStar,
        isStarred,
        isFavorited,
        onStarClicked,
        onFavoriteClicked
    };
};

async function fetchIsStarred(track, setShowStar, setIsStarred) {
    let account = await accounts.getAccount();
    let starred = await sequenceMetadata.isSequenceStarred(
        track.id);
    
    if (starred || accountsEqual(account, track.user)) {
        setShowStar(true);
    }

    setIsStarred(starred);
}

async function fetchIsFavorited(id, setIsFavorited) {
    let account = await accounts.getAccount();
    if (account === undefined) {
        return;
    }
    
    setIsFavorited(await sequenceMetadata.isSequenceFavorited(
        id,
        account));
}


const accountsEqual = (a, b) => {
    if (a === undefined ||
        b === undefined) {
        return false;
    }

    return a.toLowerCase() === b.toLowerCase();
}

